"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NodeGeoData = void 0;
class NodeGeoData {
    toJSON() {
        return {
            countryCode: this.countryCode,
            countryName: this.countryName,
            regionCode: this.regionCode,
            regionName: this.regionName,
            city: this.city,
            zipCode: this.zipCode,
            timeZone: this.timeZone,
            latitude: this.latitude,
            longitude: this.longitude,
            metroCode: this.metroCode,
        };
    }
    ;
    static fromJSON(nodeGeo) {
        if (nodeGeo === undefined) {
            return new NodeGeoData();
        }
        let nodeGeoObject;
        if (typeof nodeGeo === 'string') {
            nodeGeoObject = JSON.parse(nodeGeo);
        }
        else
            nodeGeoObject = nodeGeo;
        let newNodeGeo = new NodeGeoData();
        newNodeGeo.countryCode = nodeGeoObject.countryCode;
        newNodeGeo.countryName = nodeGeoObject.countryName;
        newNodeGeo.regionCode = nodeGeoObject.regionCode;
        newNodeGeo.regionName = nodeGeoObject.regionName;
        newNodeGeo.city = nodeGeoObject.city;
        newNodeGeo.zipCode = nodeGeoObject.zipCode;
        newNodeGeo.timeZone = nodeGeoObject.timeZone;
        newNodeGeo.latitude = nodeGeoObject.latitude;
        newNodeGeo.longitude = nodeGeoObject.longitude;
        newNodeGeo.metroCode = nodeGeoObject.metroCode;
        return newNodeGeo;
    }
}
exports.NodeGeoData = NodeGeoData;
//# sourceMappingURL=node-geo-data.js.map